<template>
  <div class="pt-5">
    <CommonExpansionPanel :currentPanel="currentPanel" :readonly="readonly">
      <template v-slot:title-panel>
        Datos Generales de la solicitud
      </template>
      <v-expansion-panel-content>
        <v-form ref="firstStepForm" :lazy-validation="true">
          <v-row>
            <v-col m="12" md="12" lg="12" xl="12">
              <v-text-field
                label="Título solicitud"
                outlined
                v-model="solicitudData.titulo"
                primary
                color="#00a7e4"
                type="text"
                :rules="requiredRule"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" lg="3" xl="3">
              <v-autocomplete
                label="Medio de contacto"
                :items="itemsOrigenSolicitud"
                v-model="solicitudData.tipo_llamada"
                placeholder="Requerido"
                outlined
                color="#00a7e4"
                :rules="requiredRule"
              ></v-autocomplete>
            </v-col>
            <v-col m="12" md="6" lg="3" xl="3">
              <v-autocomplete
                v-model="solicitudData.producto"
                label="Producto"
                placeholder="Requerido"
                color="#00a7e4"
                type="text"
                item-value="producto"
                item-text="producto"
                outlined
                :items="currentProducts"
                :rules="requiredRule"
              ></v-autocomplete>
            </v-col>
            <v-col m="12" md="6" lg="3" xl="3">
              <v-autocomplete
                v-model="solicitudData.empresa"
                label="Empresa"
                placeholder="Requerido"
                color="#00a7e4"
                item-value="empresa"
                item-text="empresa"
                :items="currentEmpresas"
                type="text"
                outlined
                :rules="requiredRule"
              ></v-autocomplete>
            </v-col>
            <v-col m="12" md="6" lg="3" xl="3">
              <v-autocomplete
                v-model="solicitudData.aseguradora"
                label="Aseguradora"
                placeholder="Requerido"
                color="#00a7e4"
                item-value="id"
                item-text="name"
                :items="currentAseguradoras"
                type="text"
                outlined
                :rules="requiredRule"
              ></v-autocomplete>
            </v-col>
            <v-col m="12" md="6" lg="3" xl="3">
              <v-autocomplete
                v-model="solicitudData.tipificacion"
                label="Tipificacion"
                placeholder="Requerido"
                color="#00a7e4"
                item-value="tipificacion"
                item-text="tipificacion"
                :items="currentTipificaciones"
                type="text"
                outlined
                :rules="requiredRule"
              ></v-autocomplete>
            </v-col>
            <v-col m="12" md="6" lg="3" xl="3">
              <v-autocomplete
                v-model="solicitudData.motivo"
                label="Motivo"
                placeholder="Requerido"
                color="#00a7e4"
                item-value="motivo"
                item-text="motivo"
                :items="currentMotivos"
                type="text"
                outlined
                :rules="requiredRule"
              ></v-autocomplete>
            </v-col>
            <v-col m="12" md="6" lg="3" xl="3">
              <v-text-field
                label="Poliza"
                outlined
                v-model="solicitudData.poliza"
                primary
                color="#00a7e4"
                type="text"
              ></v-text-field>
            </v-col>
            <v-col cols="6" sm="3" md="3" lg="3" xl="3">
              <span class="text-header-data whitout-padding-bottom ">
                ¿Es queja?
              </span>
              <v-radio-group v-model="solicitudData.isQueja" row>
                <v-radio label="Si" value="true" color="#00a7e4"></v-radio>
                <v-radio label="No" value="false" color="#00a7e4"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col m="12" md="6" lg="12" xl="12">
              <v-textarea
                v-model="solicitudData.documentos_solicitados"
                label="Documentos solicitados"
                placeholder="Requerido"
                color="#00a7e4"
                type="text"
                outlined
                :rules="requiredRule"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col m="12" md="6" lg="12" xl="12">
              <v-textarea
                v-model="solicitudData.detalle"
                label="Detalle"
                placeholder="Requerido"
                color="#00a7e4"
                type="text"
                outlined
                :rules="requiredRule"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
              xl="12"
              style="text-align: end;"
            >
              <v-btn rounded dark class="common-botton" @click="validateStep">
                <span style="padding-right: 11%;">
                  Siguiente
                </span>
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-expansion-panel-content>
    </CommonExpansionPanel>
  </div>
</template>

<script>
import CommonExpansionPanel from "@/components/commonComponents/CommonExpansionPanel.vue";
import { getCampaniasEmailsList } from "@/services/campañasEmails/campañasEmails.js";

export default {
  components: {
    CommonExpansionPanel,
  },
  props: {
    currentStep: Number,
  },
  data() {
    return {
      solicitudData: {
        tipo_llamada: null,
        producto: null,
        empresa: null,
        aseguradora: null,
        nombre_aseguradora: null,
        tipificacion: null,
        motivo: null,
        poliza: null,
        isQueja: null,
        documentos_solicitados: null,
        agenteId: null,
        detalle: null,
        titulo: null,
      },
      requiredRule: [(v) => !!v || "El campo es requerido"],
      rol: JSON.parse(localStorage.getItem("roles"))[0].rol,
      campaniasEmails: [],
      currentEmpresas: [],
      currentAseguradoras: [],
      currentTipificaciones: [],
      currentMotivos: [],
      currentPanel: 0,
      readonly: true,
      aseguradorasList: [
        { id: 1, name: "Afirme" },
        { id: 2, name: "ANA Seguros" },
        { id: 3, name: "GNP" },
        { id: 4, name: "Primero Seguros" },
        { id: 5, name: "Quálitas" },
        { id: 6, name: "Multiva" },
        { id: 7, name: "SURA RSA Seguros" },
        { id: 8, name: "AIG Seguros México" },
        { id: 9, name: "HDI Seguros" },
        { id: 10, name: "Zurich" },
        { id: 11, name: "AXA" },
        { id: 12, name: "BANORTE" },
        { id: 13, name: "ATLAS" },
        { id: 14, name: "CHUBB" },
        { id: 15, name: "GMX" },
        { id: 16, name: "ALLIANZ" },
        { id: 17, name: "ARGOS" },
        { id: 18, name: "ASERTA" },
        { id: 19, name: "BX+" },
        { id: 20, name: "MUTUUS" },
        { id: 21, name: "PLAN SEGURO" },
        { id: 22, name: "PREVEM" },
        { id: 23, name: "SISNOVA" },
        { id: 24, name: "BUPA" },
        { id: 25, name: "METLIFE" },
        { id: 26, name: "INSIGNIA" },
        { id: 27, name: "MAPFRE" },
        { id: 28, name: "EL POTOSI" },
        { id: 29, name: "Quálitas" },
        { id: 30, name: "Gnp" },
        { id: 31, name: "AIG Seguros México" },
        { id: 32, name: "Inter.mx" },
        { id: 33, name: "General de Seguros" },
      ],
    };
  },
  watch: {
    "solicitudData.producto"() {
      this.calculateEmpresas();
    },
    "solicitudData.empresa"() {
      this.calculateAseguradoras();
    },
    "solicitudData.aseguradora"() {
      this.calculateTipificaciones();
      this.getAseguradoraName();
    },
    "solicitudData.tipificacion"() {
      this.calculateMotivos();
    },
    "solicitudData.motivo"() {
      this.calculateAgenteID();
      this.calculateDatosSolicitados();
    },
    currentStep(val) {
      if (val == 1) {
        this.currentPanel = 0;
        this.readonly = false;
      } else {
        this.currentPanel = 1;
        this.readonly = true;
      }
    },
  },
  computed: {
    currentProducts() {
      var uniqueProducts = [];
      var filteredCampaigns = this.campaniasEmails;

      uniqueProducts = Array.from(
        new Set(filteredCampaigns.map((a) => a.producto))
      ).map((producto) => {
        return filteredCampaigns.find((a) => a.producto === producto);
      });

      uniqueProducts.push({
        producto: "Seguimiento",
      });

      return uniqueProducts;
    },
    itemsOrigenSolicitud() {
      return [
        "Correo electrónico",
        "Llamada telefónica",
        "Presencial",
        "Whatsapp",
        "Portal",
        "Otro",
      ];
    },
  },
  methods: {
    validateStep() {
      if (this.$refs.firstStepForm.validate()) {
        this.$emit("ChangeOnlyStep", 2, this.solicitudData);
      }
    },
    async getCampaniasEmailsList() {
      this.campaniasEmails = await getCampaniasEmailsList();
    },
    calculateEmpresas() {
      let filteredCampaigns = this.campaniasEmails.filter(
        (e) => e.producto == this.solicitudData.producto
      );
      let uniqueProducts = Array.from(
        new Set(filteredCampaigns.map((a) => a.empresa))
      ).map((empresa) => {
        return filteredCampaigns.find((a) => a.empresa === empresa);
      });
      this.currentEmpresas = uniqueProducts;
    },
    calculateAseguradoras() {
      let filteredCampaigns = this.campaniasEmails.filter(
        (e) =>
          e.producto == this.solicitudData.producto &&
          e.empresa == this.solicitudData.empresa
      );
      let uniqueProducts = Array.from(
        new Set(filteredCampaigns.map((a) => a.aseguradora_id))
      ).map((aseguradora_id) => {
        return filteredCampaigns.find(
          (a) => a.aseguradora_id === aseguradora_id
        );
      });

      const idsToFilter = uniqueProducts.map((item) => item.aseguradora_id);
      const filteredAseguradoras = this.aseguradorasList.filter((aseguradora) =>
        idsToFilter.includes(aseguradora.id)
      );

      this.currentAseguradoras = filteredAseguradoras;
    },
    calculateTipificaciones() {
      let filteredCampaigns = this.campaniasEmails.filter(
        (e) =>
          e.producto == this.solicitudData.producto &&
          e.empresa == this.solicitudData.empresa &&
          e.aseguradora_id == this.solicitudData.aseguradora
      );

      let uniqueProducts = Array.from(
        new Set(filteredCampaigns.map((a) => a.tipificacion))
      ).map((tipificacion) => {
        return filteredCampaigns.find((a) => a.tipificacion === tipificacion);
      });
      this.currentTipificaciones = uniqueProducts;
    },
    getAseguradoraName() {
      if (this.solicitudData.aseguradora) {
        const aseguradora = this.currentAseguradoras.find(
          (e) => e.id == this.solicitudData.aseguradora
        );
        if (aseguradora) {
          this.solicitudData.nombre_aseguradora = aseguradora.name;
        } else {
          console.error("Aseguradora no encontrada");
          this.solicitudData.nombre_aseguradora = null;
        }
      }
    },
    calculateMotivos() {
      let filteredCampaigns = this.campaniasEmails.filter(
        (e) =>
          e.producto == this.solicitudData.producto &&
          e.empresa == this.solicitudData.empresa &&
          e.aseguradora_id == this.solicitudData.aseguradora &&
          e.tipificacion == this.solicitudData.tipificacion
      );

      let uniqueProducts = Array.from(
        new Set(filteredCampaigns.map((a) => a.motivo))
      ).map((motivo) => {
        return filteredCampaigns.find((a) => a.motivo === motivo);
      });
      this.currentMotivos = uniqueProducts;
    },
    calculateDatosSolicitados() {
      let filteredCampaigns = this.campaniasEmails.filter(
        (e) =>
          e.producto == this.solicitudData.producto &&
          e.empresa == this.solicitudData.empresa &&
          e.aseguradora_id == this.solicitudData.aseguradora &&
          e.tipificacion == this.solicitudData.tipificacion &&
          e.motivo == this.solicitudData.motivo
      );

      let uniqueProducts = Array.from(
        new Set(filteredCampaigns.map((a) => a.documentos_solicitados))
      ).map((documentos_solicitados) => {
        return filteredCampaigns.find(
          (a) => a.documentos_solicitados === documentos_solicitados
        );
      });
      this.solicitudData.documentos_solicitados = uniqueProducts
        ? uniqueProducts[0].documentos_solicitados
        : "";
    },
    calculateAgenteID() {
      let filteredCampaigns = this.campaniasEmails.filter(
        (e) =>
          e.producto == this.solicitudData.producto &&
          e.empresa == this.solicitudData.empresa &&
          e.aseguradora_id == this.solicitudData.aseguradora &&
          e.tipificacion == this.solicitudData.tipificacion &&
          e.motivo == this.solicitudData.motivo
      );

      let uniqueProducts = Array.from(
        new Set(filteredCampaigns.map((a) => a.agente_id))
      ).map((agente_id) => {
        return filteredCampaigns.find((a) => a.agente_id === agente_id);
      });
      this.solicitudData.agenteId = uniqueProducts[0]
        ? uniqueProducts[0].agente_id
        : null;
    },
  },
  async mounted() {
    await this.getCampaniasEmailsList();
  },
};
</script>
